import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=ab25d60a&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=ab25d60a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab25d60a",
  null
  
)

export default component.exports